import { withPopup } from '../lib/popup';

import UserPasswordEditStep from './UserPasswordEditStep';

export default withPopup(UserPasswordEditStep);
